import {
  DirectionsServiceEnum,
  PROVIDERS_WITH_AVOID_TOLLS,
  RebuildRouteTypeEnum,
  resolveSkipCacheDefaultRebuildType,
  type IRideBulkRebuildRoutesPayload,
} from "@ryde/shared";

import { RIDE_BULK_REBUILD_ROUTES_CUSTOM } from "./bulk-operations.rides.constants";

/**
 * Left unset, not false, for a provider that cannot honour avoid-tolls: the backend treats any defined value as a
 * forced override that is also part of the route cache key, so unset resolves the company default like production does.
 */
const resolveBulkAvoidTolls = ({
  provider,
  avoidTolls,
}: {
  provider: DirectionsServiceEnum;
  avoidTolls: boolean;
}): boolean | undefined =>
  PROVIDERS_WITH_AVOID_TOLLS.includes(provider) ? avoidTolls : undefined;

/**
 * The first option is the default OSRM-first rebuild: it goes out as Default (or RefreshCache when cached paths
 * are skipped), exactly like the ride form, so the result is saved to the route cache when the category allows it.
 */
const resolveBulkRebuildType = ({
  rebuildType,
  skipCachedPaths,
}: {
  rebuildType: RebuildRouteTypeEnum;
  skipCachedPaths: boolean;
}): RebuildRouteTypeEnum =>
  rebuildType === RIDE_BULK_REBUILD_ROUTES_CUSTOM.defaultRebuildType
    ? resolveSkipCacheDefaultRebuildType({ skipCachedPaths })
    : rebuildType;

export const buildBulkRebuildRoutesCustomPayload = ({
  ids,
  rebuildType,
  provider,
  avoidTolls,
  skipCachedPaths,
  skipMlPath,
}: {
  ids: number[];
  rebuildType: RebuildRouteTypeEnum;
  provider: DirectionsServiceEnum;
  avoidTolls: boolean;
  skipCachedPaths: boolean;
  skipMlPath: boolean;
}): IRideBulkRebuildRoutesPayload => ({
  ids,
  rebuildType: resolveBulkRebuildType({ rebuildType, skipCachedPaths }),
  provider,
  avoidTolls: resolveBulkAvoidTolls({ provider, avoidTolls }),
  skipCachedPaths,
  skipMlPath,
});
